// ACTIONS ON REVIEWS
export const GET_SINGLE_REVIEWS = 'GET_SINGLE_REVIEWS';
export const GET_SINGLE_REVIEWS_SUCCESS = 'GET_SINGLE_REVIEWS_SUCCESS';
export const GET_SINGLE_REVIEWS_FAILURE = 'GET_SINGLE_REVIEWS_FAILURE';

export const GET_SINGLE_INTERVIEW_REVIEWS = 'GET_SINGLE_INTEVIEW_REVIEWS';
export const GET_SINGLE_INTERVIEW_REVIEWS_SUCCESS =
  'GET_SINGLE_INTERVIEW_REVIEWS_SUCCESS';
export const GET_SINGLE_INTERVIEW_REVIEWS_FAILURE =
  'GET_SINGLE_INTEVIEW_REVIEWS_FAILURE';

export const GET_SINGLE_COMPANY_REVIEWS = 'GET_SINGLE_COMPANY_REVIEWS';
export const GET_SINGLE_COMPANY_REVIEWS_SUCCESS =
  'GET_SINGLE_COMPANY_REVIEWS_SUCCESS';
export const GET_SINGLE_COMPANY_REVIEWS_FAILURE =
  'GET_SINGLE_COMPANY_REVIEWS_FAILURE';

export const GET_SINGLE_COMPANY_INTERVIEW_REVIEWS =
  'GET_SINGLE_COMPANY_INTERVIEW_REVIEWS';
export const GET_SINGLE_COMPANY_INTERVIEW_REVIEWS_SUCCESS =
  'GET_SINGLE_COMPANY_INTERVIEW_REVIEWS_SUCCESS';
export const GET_SINGLE_COMPANY_INTERVIEW_REVIEWS_FAILURE =
  'GET_SINGLE_COMPANY_INTERVIEW_REVIEWS_FAILURE';

export const GET_SINGLE_COMPANY_SALARY_REVIEWS =
  'GET_SINGLE_COMPANY_SALARY_REVIEWS';
export const GET_SINGLE_COMPANY_SALARY_REVIEWS_SUCCESS =
  'GET_SINGLE_COMPANY_SALARY_REVIEWS_SUCCESS';
export const GET_SINGLE_COMPANY_SALARY_REVIEWS_FAILURE =
  'GET_SINGLE_COMPANY_SALARY_REVIEWS_FAILURE';

export const GET_COMPANY_REVIEWS = 'GET_COMPANY_REVIEWS';
export const GET_COMPANY_REVIEWS_SUCCESS = 'GET_COMPANY_REVIEWS_SUCCESS';
export const GET_COMPANY_REVIEWS_FAILURE = 'GET_COMPANY_REVIEWS_FAILURE';
export const ADD_COMPANY_REVIEW = 'ADD_COMPANY_REVIEW';
export const ADD_COMPANY_REVIEW_SUCCESS = 'ADD_COMPANY_REVIEW_SUCCESS';
export const ADD_COMPANY_REVIEW_FAILURE = 'ADD_COMPANY_REVIEW_FAILURE';

export const DELETE_COMPANY_REVIEWS = 'DELETE_COMPANY_REVIEWS';
export const DELETE_COMPANY_REVIEWS_SUCCESS = 'DELETE_COMPANY_REVIEWS_SUCCESS';
export const DELETE_COMPANY_REVIEWS_FAILURE = 'DELETE_COMPANY_REVIEWS_FAILURE';

export const UPDATE_COMPANY_REVIEWS = 'UPDATE_COMPANY_REVIEWS';
export const UPDATE_COMPANY_REVIEWS_SUCCESS = 'UPDATE_COMPANY_REVIEWS_SUCCESS';
export const UPDATE_COMPANY_REVIEWS_FAILURE = 'UPDATE_COMPANY_REVIEWS_FAILURE';

export const GET_CURRENCY_RATES = 'GET_CURRENCY_RATES';
export const GET_CURRENCY_RATES_SUCCESS = 'GET_CURRENCY_RATES_SUCCESS';
export const GET_CURRENCY_RATES_FAILURE = 'GET_CURRENCY_RATES_FAILURE';

export const GET_SALARY_REVIEWS = 'GET_SALARY_REVIEWS';
export const GET_SALARY_REVIEWS_SUCCESS = 'GET_SALARY_REVIEWS_SUCCESS';
export const GET_SALARY_REVIEWS_FAILURE = 'GET_SALARY_REVIEWS_FAILURE';
export const ADD_SALARY_REVIEW = 'ADD_SALARY_REVIEW';
export const ADD_SALARY_REVIEW_SUCCESS = 'ADD_SALARY_REVIEW_SUCCESS';
export const ADD_SALARY_REVIEW_FAILURE = 'ADD_SALARY_REVIEW_FAILURE';
export const DELETE_SALARY_REVIEWS = 'DELETE_SALARY_REVIEWS';
export const DELETE_SALARY_REVIEWS_SUCCESS = 'DELETE_SALARY_REVIEWS_SUCCESS';
export const DELETE_SALARY_REVIEWS_FAILURE = 'DELETE_SALARY_REVIEWS_FAILURE';
export const UPDATE_SALARY_REVIEWS = 'UPDATE_SALARY_REVIEWS';
export const UPDATE_SALARY_REVIEWS_SUCCESS = 'UPDATE_SALARY_REVIEWS_SUCCESS';
export const UPDATE_SALARY_REVIEWS_FAILURE = 'UPDATE_SALARY_REVIEWS_FAILURE';

export const GET_INTERVIEW_REVIEWS = 'GET_INTERVIEW_REVIEWS';
export const GET_INTERVIEW_REVIEWS_SUCCESS = 'GET_INTERVIEW_REVIEWS_SUCCESS';
export const GET_INTERVIEW_REVIEWS_FAILURE = 'GET_INTERVIEW_REVIEWS_FAILURE';

export const ADD_INTERVIEW_REVIEW = 'ADD_INTERVIEW_REVIEW';
export const ADD_INTERVIEW_REVIEW_SUCCESS = 'ADD_INTERVIEW_REVIEW_SUCCESS';
export const ADD_INTERVIEW_REVIEW_FAILURE = 'ADD_INTERVIEW_REVIEW_FAILURE';

export const DELETE_INTERVIEW_REVIEW = 'DELETE_INTERVIEW_REVIEW';
export const DELETE_INTERVIEW_REVIEW_SUCCESS =
  'DELETE_INTERVIEW_REVIEW_SUCCESS';
export const DELETE_INTERVIEW_REVIEW_FAILURE =
  'DELETE_INTERVIEW_REVIEW_FAILURE';

export const UPDATE_INTERVIEW_REVIEW = 'UPDATE_INTERVIEW_REVIEW';
export const UPDATE_INTERVIEW_REVIEW_SUCCESS =
  'UPDATE_INTERVIEW_REVIEW_SUCCESS';
export const UPDATE_INTERVIEW_REVIEW_FAILURE =
  'UPDATE_INTERVIEW_REVIEW_FAILURE';

export const GET_HIGHEST = 'GET_HIGHEST';
export const GET_HIGHEST_SUCCESS = 'GET_HIGHEST_SUCCESS';
export const GET_HIGHEST_FAILURE = 'GET_HIGHEST_FAILURE';

export const GET_AVG_SALARIES = 'GET_AVG_SALARIES';
export const GET_AVG_SALARIES_SUCCESS = 'GET_AVG_SALARIES_SUCCESS';
export const GET_AVG_SALARIES_FAILURE = 'GET_AVG_SALARIES_FAILURE';

export const GET_TOP_RATED = 'GET_TOP_RATED';
export const GET_TOP_RATED_SUCCESS = 'GET_TOP_RATED_SUCCESS';
export const GET_TOP_RATED_FAILURE = 'GET_TOP_RATED_FAILURE';

export const GET_CLOSEST_COMPANIES = 'GET_CLOSEST_COMPANIES';
export const GET_CLOSEST_COMPANIES_SUCCESS = 'GET_CLOSEST_COMPANIES_SUCCESS';
export const GET_CLOSEST_COMPANIES_FAILURE = 'GET_CLOSEST_COMPANIES_FAILURE';

// ACTION TYPES FOR AUTH
export const LOG_IN_USER = 'LOG_IN_USER';
export const LOG_IN_USER_SUCCESS = 'LOG_IN_USER_SUCCESS';
export const LOG_IN_USER_FAILURE = 'LOG_IN_USER_FAILURE';
export const LOG_OUT_USER = 'LOG_OUT_USER';
export const LOG_OUT_USER_SUCCESS = 'LOG_OUT_USER_SUCCESS';
export const LOG_OUT_USER_FAILURE = 'LOG_OUT_USER_FAILURE';
export const EDIT_ALL_USER_PROFILE = 'EDIT_ALL_USER_PROFILE';

export const EDIT_PROFILE_PICTURE = 'EDIT_PROFILE_PICTURE_REVIEWS';
export const EDIT_PROFILE_PICTURE_SUCCESS = 'EDIT_PROFILE_PICTURE_SUCCESS';
export const EDIT_PROFILE_PICTURE_FAILURE = 'EDIT_PROFILE_PICTURE_FAILURE';

export const GET_INTERESTS = 'GET_INTERESTS';
export const GET_INTERESTS_FAILURE = 'GET_INTERESTS_FAILURE';
export const GET_INTERESTS_SUCCESS = 'GET_INTERESTS_SUCCESS';

export const GET_USER_INTERESTS = 'GET_USER_INTERESTS';
export const GET_USER_INTERESTS_FAILURE = 'GET_USER_INTERESTS_FAILURE';
export const GET_USER_INTERESTS_SUCCESS = 'GET_USER_INTERESTS_SUCCESS';

export const DELETE_INTEREST = 'DELETE_INTEREST';
export const ADD_INTEREST = 'ADD_INTEREST';

// ACTIONS FOR COMPANIES
export const GET_COMPANIES = 'GET_COMPANIES';
export const GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS';
export const GET_COMPANIES_FAILURE = 'GET_COMPANIES_FAILURE';
export const ADD_COMPANY = 'ADD_COMPANY';
export const ADD_COMPANY_SUCCESS = 'ADD_COMPANY_SUCCESS';
export const ADD_COMPANY_FAILURE = 'ADD_COMPANY_FAILURE';

// ACTIONS FOR SEARCH
export const SEARCH = 'SEARCH';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

// CHAT STATE
export const CHAT_OPEN = 'CHAT_OPEN';
export const GET_OPEN_CHATS = 'GET_OPEN_CHATS';
export const SET_CHAT_MESSAGES = 'SET_CHAT_MESSAGES';
export const CLOSE_CHAT = 'CLOSE_CHAT';
// CLOSE STATE
export const ISCLOSE_CHANGE =  'ISCLOSE_CHANGE';
// SELECTED USER STATE
export const GET_SELECTED_USER_DETAILS = 'GET_SELECTED_USER_DETAILS';
export const GET_SELECTED_USER_DETAILS_SUCCESS = 'GET_SELECTED_USER_DETAILS_SUCCESS';
export const GET_SELECTED_USER_DETAILS_FAILURE = 'GET_SELECTED_USER_DETAILS_FAILURE';

